export default function CalculateAnonUserInfo(propertyData, geoData, housingMarketData) {

    // console.log('PROPERTY DATA + GEO DATA + HOUSING MARKET DATA', propertyData, geoData, housingMarketData);

    const userPersonalInfo = {
        householdIncome: null,
        availableFunds: null,
        relationToProperty: 'owner',
        monthlyMortgagePayment: null,
        expectedPurchasePrice: null,
        isComplete: true
    }

  // ------------------------------------------------------------
    // GETTING THE AREA HOUSEHOLD INCOME
    const areaHouseholdIncome = housingMarketData?.originalValues.highestIncomeLevel.value_today;
    // ------------------------------------------------------------

    // ------------------------------------------------------------
    // GETTING THE CURRENT HOME VALUE
    const userInputForm = propertyData?.data?.user_input_form || [];
    
    // Find the datapoint with id '44'
    const currentHomeValueObject = userInputForm.find(datapoint => datapoint.id === '44') || {};
    const currentHomeValue = currentHomeValueObject.datapoint_value;
    // ------------------------------------------------------------

    // ------------------------------------------------------------
    // GETTING THE LAST MONTH'S AVG SALE PRICE
    const lastMonthAvgSalePriceFips = geoData?.fips?.data?.[0]?.median_sale_price || 0;
    
    const lastMonthAvgSalePriceZip = geoData?.zip?.data?.[0]?.median_sale_price || 0;
    
    const lastMonthValueToUse = lastMonthAvgSalePriceFips > lastMonthAvgSalePriceZip ? lastMonthAvgSalePriceFips : lastMonthAvgSalePriceZip;
    // ------------------------------------------------------------

    // ------------------------------------------------------------
    // GETTING THE IMPLIED INCOME
    const impliedIncomeKicker = lastMonthValueToUse / currentHomeValue;
    const impliedIncome = Math.round(areaHouseholdIncome * impliedIncomeKicker);
    // ------------------------------------------------------------
    
    // ------------------------------------------------------------
    // DETERMINING THE AVAILABLE FUNDS
    const howMuchOfIncomeToUse = 0.33;
    const availableFunds = Math.round(areaHouseholdIncome * howMuchOfIncomeToUse);
    // ------------------------------------------------------------
    
    // ------------------------------------------------------------
    // DETERMINING THE MONTHLY MORTGAGE PAYMENT
    const monthlyMortgagePaymentKicker = 0.0015;
    const monthlyMortgagePayment = Math.round(currentHomeValue * monthlyMortgagePaymentKicker);
    // ------------------------------------------------------------
    
    // ------------------------------------------------------------
    // SETTING THE USER PERSONAL INFO
    userPersonalInfo.householdIncome = impliedIncome;
    userPersonalInfo.availableFunds = Math.round(areaHouseholdIncome * 0.33);
    userPersonalInfo.monthlyMortgagePayment = Math.round(currentHomeValue * .0015);
    userPersonalInfo.expectedPurchasePrice = currentHomeValue;
    // ------------------------------------------------------------
    
    // console.log('AREA HOUSEHOLD INCOME', areaHouseholdIncome);
    // console.log('CURRENT HOME VALUE', currentHomeValue, currentHomeValueObject);
    // console.log('LAST MONTH AVG SALE PRICE FIPS', lastMonthAvgSalePriceFips);
    // console.log('LAST MONTH AVG SALE PRICE ZIP', lastMonthAvgSalePriceZip);
    // console.log('LAST MONTH VALUE TO USE', lastMonthValueToUse);
    // console.log('IMPLIED INCOME KICKER', impliedIncomeKicker);
    // console.log('IMPLIED INCOME', impliedIncome);
    // console.log('USER PERSONAL INFO', userPersonalInfo);

    return userPersonalInfo;

}
